var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.initialRenderMode
      ? _c(
          "div",
          { staticClass: "numeration" },
          [
            _c("LfHeaderTitle", {
              staticClass: "header-title",
              attrs: { title: _vm.headerTitle },
            }),
            _c("NumerationGridComponent", {
              on: {
                "row-click": _vm.onRowClicked,
                "command-click": _vm.onCommandClick,
                "toolbar-click": _vm.onToolbarClicked,
                "context-menu-click": _vm.onContextMenuClicked,
              },
            }),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "numeration_edit" },
          [
            _c("LfHeaderTitle", {
              staticClass: "header-title",
              attrs: {
                title: _vm.formTitle,
                buttons: _vm.buttons,
                executeAction: _vm.onExecuteAction,
              },
            }),
            _vm.formSchema
              ? _c(
                  "FormGeneratorComponent",
                  {
                    attrs: {
                      schema: _vm.formSchema,
                      fieldValues: _vm.formData,
                      context: _vm.context,
                      showRequiredFieldsAdvice: "",
                      appendElementId: "actived",
                    },
                    on: {
                      mountedForm: _vm.checkDisabled,
                      saveFormData: _vm.prepareFormDataToSave,
                    },
                  },
                  [
                    _vm.getCustomConfigText
                      ? _c(
                          "div",
                          {
                            staticClass: "numeration-info-container",
                            attrs: { slot: "appendElement" },
                            slot: "appendElement",
                          },
                          [
                            _c("span", {
                              staticClass: "icon-code lf-icon-code lf-icon__md",
                            }),
                            _c("div", { staticClass: "text-container" }, [
                              _c("p", { staticClass: "info-text" }, [
                                _vm._v(_vm._s(_vm.getCustomConfigText)),
                              ]),
                              _c("span", { staticClass: "info-code" }, [
                                _vm._v(_vm._s(_vm.code)),
                              ]),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }